export const PERSIST_ROOT_KEY = 'fingo_persist:root'
export const PERSIST_ROOT_VERSION = 3

export const BATCH_EVENT_TYPE_TIME_SPENT = 'time_spent'

export const AMOUNT_OF_GEMS_REDEEM_TO_HEARTS = 25

export const MAX_HEARTS = 5

export const HOUR_OF_UNLIMITED_HEARTS = 72

export const HEARTS_REFILL_RATE = 60 // refill rate in minutes

export const MAX_REDEEM_GIFT_CARD_PER_MONTH = 2

export const NUMBER_OF_SUCCESS_REFERRALS = 3

export const DEFAULT_GUEST_NAME = 'Stranger'

export const NUMBER_OF_LIMIT_LESSON_FOR_GUEST = 5

export const DEFAULT_ACTIVE_SOUND = true

export const __DEV__ = process.env.NODE_ENV === 'development'
